<template>
  <div class="about">
       <!-- Navigation -->
        <nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top" id="mainNav">
            <div class="container">
            <router-link :to="{name: 'Home', hash:'#page-top'}" class="navbar-brand js-scroll-trigger"><img src="@/assets/img/navbar-logo5.png" alt="" /></router-link> 
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
                <div class="collapse navbar-collapse" id="navbarResponsive">
                    <ul class="navbar-nav ml-auto">
                    <li class="nav-item">
                        <router-link :to="{name: 'Home', hash:'#bar'}" class="nav-link js-scroll-trigger text-uppercase">unser lokal</router-link>    <!--<a class="nav-link js-scroll-trigger text-uppercase" href="#bar">unser lokal</a>-->
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'Home', hash:'#menus'}" class="nav-link js-scroll-trigger text-uppercase">Menus</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'Home', hash:'#handl'}" class="nav-link js-scroll-trigger text-uppercase">Öffnungszeiten & Anfahrt</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'Home', hash:'#contact'}" class="nav-link js-scroll-trigger text-uppercase">Kontakt</router-link>
                    </li>
                    </ul>
                </div>
            </div>
        </nav>
        
        <!-- Impressumcontent -->
        <Impressumcontent></Impressumcontent>
 </div> 
</template>


<script>
import Impressumcontent from '@/components/impressumcontent.vue'

export default {
  name: 'App',
  components: {
    Impressumcontent
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.mascontainer {
  width: 100%;
  padding-right: 0.75rem;
  padding-left: 0.75rem;
  margin-right: auto;
  margin-left: auto;
  background: rgba(78, 78, 77, 0.39);
}

</style>
